<!-- acions row -->
<div fxLayout="row">
  <div fxFlex="0 1">
    <button
      aria-label="Icon button to remove selected benefit"
      class="action-button fo-color-error"
      matButton="filled"
      (click)="cancelSelection.emit()"
    >
      {{ 'general.cancel' | translate | uppercase }}&nbsp;
      <mat-icon>cancel</mat-icon>
    </button>
  </div>

  <div class="align-right" fxFlex="0 2">
    <button
      aria-label="Icon button to send selected benefit"
      class="action-button fo-color-secondary"
      matButton="filled"
      [disabled]="sendDisabled || isConfirmed"
      (click)="confirm()"
    >
      {{ 'general.conf' | translate | uppercase }}&nbsp;
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
